import { render } from "./UploadBtn.vue?vue&type=template&id=0aca4654&scoped=true"
const script = {}

import "./UploadBtn.vue?vue&type=style&index=0&id=0aca4654&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aca4654"]])

export default __exports__